export const headerVariants: any = {
  hidden: { opacity: 0, y: -28 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] },
  },
};

export const accentBarVariants: any = {
  hidden: { scaleX: 0, originX: 0 },
  visible: {
    scaleX: 1,
    transition: { duration: 0.38, ease: [0.22, 1, 0.36, 1], delay: 0.12 },
  },
};

export const wordVariants: any = {
  hidden: { opacity: 0, y: 14 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      // was 0.18 + i*0.08 — last of 4 words appeared at 0.42s+
      delay: 0.08 + i * 0.05,
      duration: 0.38,
      ease: [0.22, 1, 0.36, 1],
    },
  }),
};

export const rightSectionVariants: any = {
  hidden: { opacity: 0, x: 30 },
  visible: {
    opacity: 1,
    x: 0,
    // was 0.28 — halved
    transition: { duration: 0.42, ease: [0.22, 1, 0.36, 1], delay: 0.12 },
  },
};

export const exitVariants: any = {
  hidden: { opacity: 0, scale: 0.7, rotate: -10 },
  visible: {
    opacity: 1,
    scale: 1,
    rotate: 0,
    // was 0.48 — halved
    transition: { type: "spring", stiffness: 340, damping: 24, delay: 0.2 },
  },
};
